/* IMPORT HERE */

import { ThemeUICSSObject } from 'theme-ui';
import { focusOutline } from '../../../../util';

export const materialInput: ThemeUICSSObject = {
  position: 'relative',
  display: 'inline-flex',
  width: 'max-content',
  flexDirection: 'column',
  background: 'white',
  borderRadius: '6px',

  span: {
    transition: 'top 200ms, left 200ms, font-size 200ms, background 200ms',
    position: 'absolute',
    top: '10px',
    left: '8px',
    fontSize: '14px',
    pointerEvents: 'none',
    color: 'palette.border.section',
    background: 'transparent',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '144px',
    overflow: 'hidden',
  },

  '&:focus-within': focusOutline,

  '&.filled, &:focus-within': {
    span: {
      position: 'absolute',
      top: '4px',
      left: '5px',
      fontSize: '10px',
      pointerEvents: 'all',
      background: 'white',
      padding: '0 2px',
    },

    input: {
      paddingTop: '15px',
      opacity: 1,
    },
  },

  '& *:focus': {
    outline: 'none',
  },

  input: {
    border: '1px solid #ccc',
    borderRadius: 'panel',
    transition: 'padding 200ms, opacity 400ms',
    background: 'none',
    padding: '8px',
    opacity: 0,
  },
};
